export default __webpack_public_path__ + "static/media/mila.cb0b3ca2.png";